export const templates = {
  Solo: 'Solo',
};
